<template>
  <v-list-item :key="sensor.uuid" class="sensor-pill" :style="titleColor">
    <v-list-item-content>
      <v-list-item-title
        >{{ sensor.name }}
        <v-progress-circular
          v-if="loading"
          :size="16"
          :width="1"
          indeterminate
        ></v-progress-circular>
      </v-list-item-title>

      <v-list-item-subtitle>
        <span v-if="sensor.name != sensor.sensor.name">{{
          sensor.sensor.name
        }}</span>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="noData">
      <v-list-item-action-text class="text-none">{{
        $t("components.miscellaneous.sensorPill.noData")
      }}</v-list-item-action-text>
    </v-list-item-action>
    <v-list-item-action>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-list-item-action-text
            v-bind="attrs"
            v-on="on"
            v-text="sensor.last_record_value"
          ></v-list-item-action-text>
        </template>
        <span>{{
          $moment(sensor.last_record_at).format("YYYY-MM-DD H:mm:ss a")
        }}</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: "SensorPill",
  props: {
    sensor: Object,
    selected: Boolean,
    loading: Boolean,
    noData: Boolean,
  },
  data: () => ({
    start: null,
    end: new Date(),
    selectedSensors: [],
  }),
  computed: {
    titleColor() {
      if (this.selected) {
        return `border-color: ${this.sensor.color}`;
      }
      return "";
    },
    elevation() {
      if (this.selected) {
        return 2;
      } else {
        return 0;
      }
    },
  },
};
</script>

<style>
.sensor-pill {
  border-right: 6px solid transparent;
  cursor: pointer;
}
</style>
